import React from "react";
import ReactEcharts from "echarts-for-react";
import { Grid, Box, Paper } from "@mui/material";
import * as echarts from "echarts";
const InsuranceMisChart = ({ data }) => {
  if (!data) return null;

const chartData = [
  { value: data?.total_crop_insurance_leads, name: "Crop" },
  { value: data?.total_cattle_insurance_leads, name: "Cattle" },
  { value: data?.total_motor_insurance_leads, name: "Motor" },
  { value: data?.total_health_insurance_leads, name: "Health" },
//   { value: data?.total_shopkeeper_insurance_leads, name: "Shopkeeper" },
];

const categoryChart = {
  title: {
    text: "Insurance Leads by Category",
    left: "center",
    top: "4%",
    textStyle: { fontSize: 14, fontWeight: 600, color: "#333" },
  },
  tooltip: {
    trigger: "item",
    formatter: "{b}: {c} ({d}%)",
  },
  legend: {
    orient: "vertical",
    left: "1%",
    top: "middle",
    textStyle: { color: "#111827", fontWeight: 500, fontSize: 13 },
    formatter: function (name) {
      const item = chartData?.find((a) => a.name === name);
      return `${name}  - ${item ? item.value : 0}`;
    },
  },
  series: [
    {
      name: "Leads",
      type: "pie",
      radius: ["45%", "70%"],
      center: ["65%", "55%"],
      data: chartData,
      label: {
        show: true,
        formatter: "{b}",
        fontSize: 11,
        color: "#444",
      },
      labelLine: { length: 12, length2: 8 },
      itemStyle: {
        borderRadius: 8,
        borderColor: "#fff",
        borderWidth: 2,
      },
      color: [
        "#F5B041",  
        "#5470c6",
        "#81C784",
        "#BA68C8",
        "#E57373",
      ],
    },
  ],
};

const trendChart = {
  title: {
    text: "Lead Generation Trend",
    left: "center",
    top: "4%",
    textStyle: { fontSize: 14, fontWeight: 600 },
  },
  tooltip: {
    trigger: "axis",
    formatter: "{b}: {c} leads",
  },
  grid: {
    top: "20%",
    left: "10%",
    right: "8%",
    bottom: "12%",
  },
  xAxis: {
    type: "category",
    data: ["Today", "Last 7 Days", "1 Month", "6 Months", "1 Year"],
    axisLabel: { fontSize: 11 },
  },
  yAxis: {
    type: "value",
    axisLabel: { fontSize: 11 },
    splitLine: { lineStyle: { color: "#eee" } },
  },
  series: [
    {
      name: "Leads",
      type: "bar",
      data: [
        data?.total_leads_generated_today,
        data?.total_leads_generated_last_7_days,
        data?.total_leads_generated_last_1_month,
        data?.total_leads_generated_last_6_months,
        data?.total_leads_generated_last_1_year,
      ],
      barWidth: "45%",
      itemStyle: {
        borderRadius: [6, 6, 0, 0],
       color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "#91cc75" }, 
          { offset: 1, color: "#d8f3dc" }, 
        ]),
      },
    },
  ],
};


  return (
  
      <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              sx={{ p: 2, borderRadius: 3, backgroundColor: "#fff" }}>
          <ReactEcharts option={categoryChart} style={{ height: 320 }} />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              sx={{ p: 2, borderRadius: 3, backgroundColor: "#fff" }}>
          <ReactEcharts option={trendChart} style={{ height: 320 }} />
            </Paper>
          </Grid>
        </Grid>
  );
};

export default InsuranceMisChart;
